import { render, staticRenderFns } from "./ShopHome.vue?vue&type=template&id=0eb3c3fd&scoped=true&"
import script from "./ShopHome.vue?vue&type=script&lang=js&"
export * from "./ShopHome.vue?vue&type=script&lang=js&"
import style0 from "./ShopHome.vue?vue&type=style&index=0&id=0eb3c3fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eb3c3fd",
  null
  
)

export default component.exports